
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/free-trial-biologics",
      function () {
        return require("private-next-pages/free-trial-biologics/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/free-trial-biologics"])
      });
    }
  